var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.outletInfo)?_c('div',{staticClass:"mb-3",class:[ {'cx-dashboard-header-default': _vm.marginOverview }, 
                {'cx-dashboard-header-nomargin': !_vm.marginOverview} ]},[_c('CxOutletOverview',{attrs:{"outletInfo":_vm.outletInfo,"theme":_vm.theme}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }